import { useService } from 'react-reservice';

import { ISymbolTopicLivePrices } from '@aqx-core/common/socket/subscriptions';

import { symbolPriceService } from './service';

export const useOrderSymbolPrices = (id: string) =>
  useService(symbolPriceService, (context) => {
    return context.mappedSymbolPrices[id] || ({} as ISymbolTopicLivePrices);
  });
